// View-model types for the treasury accounts module — the platform's
// own settlement bank accounts. Produced by
// ../api/treasuryAccountsParser.ts. Consumers (containers, components,
// composables) bind to these — never to the wire DTOs in
// ../api/treasuryAccountsContracts.ts.

export enum TREASURY_BANK_ACCOUNT_STATUS {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ARCHIVED = 'archived',
}

export type TreasuryBankAccountStatus = `${TREASURY_BANK_ACCOUNT_STATUS}`

// ─── List item (summary shape returned by GET) ──────────────────────────────

export interface TreasuryBankAccount {
  id: string
  accountName: string
  bankName: string
  currencyCode: string
  countryCode: string
  status: TreasuryBankAccountStatus
  isDefault: boolean
}

// ─── Detail (returned by POST/PATCH/POST set-default/deactivate) ────────────

export interface TreasuryBankAccountDetail {
  id: string
  accountName: string
  bankName: string
  accountNumber: string
  iban: string | null
  swiftBic: string | null
  currencyCode: string
  countryCode: string
  status: TreasuryBankAccountStatus
  isDefault: boolean
  notes: string | null
  createdAt: string
  updatedAt: string
}

// ─── Request inputs ──────────────────────────────────────────────────────────

export interface GetTreasuryBankAccountsParams {
  status?: TreasuryBankAccountStatus
  currencyCode?: string
}

export interface CreateTreasuryAccountInput {
  accountName: string
  bankName: string
  accountNumber: string
  iban: string | null
  swiftBic: string | null
  currencyCode: string
  countryCode: string
  notes: string | null
  isDefault: boolean
  idempotencyKey: string
}

export interface UpdateTreasuryAccountInput {
  id: string
  accountName?: string
  bankName?: string
  iban?: string | null
  swiftBic?: string | null
  notes?: string | null
}

export interface IdempotentTreasuryAccountInput {
  id: string
  idempotencyKey: string
}
